'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;

  min-width: 300px;
  width: 300px;
  height: 370px;

  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    cursor: pointer;
    transform: translateY(-4px);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.05),
      0 8px 24px rgba(0, 0, 0, 0.08),
      0 24px 48px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  padding: 12px 8px;
  gap: 8px;

  border-radius: 0 0 16px 16px;
  background-color: ${colors.light};
`;

export const Title = styled.div`
  color: ${colors.dark};
  font-weight: 600;
  font-size: 1.125rem;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: auto;
  gap: 10px;

  font-size: 0.9rem;
`;

export const TopImageSection = styled.div`
  display: flex;
  flex-wrap: wrap;

  width: 100%;
  padding: 0 12px;
  gap: 4px;

  position: absolute;
  top: 5px;
  right: 0;
`;

export const Ribbon = styled.div`
  padding: 4px 12px;

  border-radius: 16px;
  user-select: none;
  background-color: ${({ $color }) => colors[$color] || colors.light};
  color: ${colors.light};
`;

export const RegistrationCounter = styled.div`
  width: fit-content;
  padding: 4px 12px;

  font-size: 0.9rem;
  border-radius: 16px;
  user-select: none;
  background-color: ${colors.red};
  color: ${colors.light};
`;

export const BottomImageSection = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 0 12px;
  gap: 4px;

  position: absolute;
  bottom: 5px;
  right: 0;
  text-transform: uppercase;
`;

export const Venues = styled.div`
  display: flex;
  justify-content: flex-end;

  gap: 8px;
`;

export const Venue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  gap: 4px;

  overflow: hidden;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 12px;
  user-select: none;
  background-color: ${({ $color }) => colors[$color] || colors.aqua};
  color: ${colors.light};

  & > span {
    line-height: 0.8;
  }
`;

export const PlayWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  visibility: hidden;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 50px;
  width: 50px;

  color: ${colors.dark};
  background: ${colors.blue};
  border-radius: 50%;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${breakpoints.mobile}) {
    visibility: visible;
  }
`;

export const ImageWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  position: relative;

  height: 215px;
  border-radius: 16px 16px 0 0;

  & > img {
    max-width: 100%;
    border-radius: 16px 16px 0 0;
  }

  &:hover {
    & > img {
      filter: ${({ $hasTrailer }) => $hasTrailer && 'brightness(50%)'};
      transition: all 0.3s ease-in-out;
    }

    ${PlayWrap} {
      visibility: visible;
    }

    ${Venue} {
      transition: all 0.2s ease-in-out;
      transform: scale(1.15);
    }
  }
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;

  gap: 6px;

  font-size: 0.9rem;
`;

export const Grade = styled.div`
  display: flex;
  align-items: center;

  gap: 6px;

  font-size: 0.9rem;
  line-height: 0.9;

  & > span:first-child {
    font-weight: 600;
  }

  & > span:nth-child(3) {
    font-weight: 300;
  }
`;
